import Api from 'utils/ApiRequest'
import API_TOTEM from 'constants/api'
import { showSpinner, hideSpinner } from 'action/spinner'
import { getPages } from 'component/pagination/utils'

import {
  FETCH_TOTEM_LOGS_REQUEST,
  FETCH_TOTEM_LOGS_SUCCESS,
  FETCH_TOTEM_LOGS_ERROR,
} from 'actionTypes'

const DEFAULT_PAGE = 1
const DEFAULT_SIZE = 10

export const fetchLogs = (token, filters) => (dispatch) => {
  const actualPage = filters.page || DEFAULT_PAGE

  const params = {
    ...filters,
    offset: DEFAULT_SIZE * actualPage - DEFAULT_SIZE,
    page: actualPage,
    size: DEFAULT_SIZE,
  }

  const EXCLUDED_LOG = 5
  if (params.logType !== EXCLUDED_LOG) {
    dispatch(request())
    return new Api(token, dispatch)
      .post(API_TOTEM.TOTEM_LOG, params)
      .then(dispatch(showSpinner()))
      .then((response) => {
        dispatch(getPages(response.data.pages))
        dispatch(requestSuccess(response.data.resultList))
        dispatch(hideSpinner())
      })
      .catch((error) => {
        dispatch(requestError(error))
        dispatch(hideSpinner())
      })
  }

  if (params.logType === EXCLUDED_LOG) {
    dispatch(request())
    return new Api(token, dispatch)
      .post(API_TOTEM.TOTEM_LOG_EXCLUDED, params)
      .then(dispatch(showSpinner()))
      .then((response) => {
        dispatch(getPages(response.data.pages))
        dispatch(requestSuccess(response.data.resultList))
        dispatch(hideSpinner())
      })
      .catch((error) => {
        dispatch(requestError(error))
        dispatch(hideSpinner())
      })
  }
}

export const clearTable = () => (dispatch) => {
  dispatch(requestSuccess([]))
}

const requestSuccess = (data) => ({
  type: FETCH_TOTEM_LOGS_SUCCESS,
  payload: data,
})

const requestError = (error) => ({
  type: FETCH_TOTEM_LOGS_ERROR,
  payload: error,
})

const request = () => ({
  type: FETCH_TOTEM_LOGS_REQUEST,
})
